import { ITemplateField, TemplateFieldModel } from './template-field.model';

export interface IPrefillValue {
  prefillValueId: string;
  prefillId: string;
  templateFieldId: string;
  value: string;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  templateField?: ITemplateField | null;
}

export class PrefillValueModel {
  prefillValueId: string;
  prefillId: string;
  templateFieldId: string;
  value: string;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;
  templateField: TemplateFieldModel | null;

  constructor(data: IPrefillValue) {
    this.prefillValueId = data.prefillValueId;
    this.prefillId = data.prefillId;
    this.templateFieldId = data.templateFieldId;
    this.value = data.value;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.templateField = data.templateField ? new TemplateFieldModel(data.templateField) : null;
  }
}
